import { createApp } from "vue";
import { createPinia } from "pinia";
import App from "./App.vue";
import { router } from "./router";
import vuetify from "./plugins/vuetify";
import "@/scss/style.scss";
import PerfectScrollbar from "vue3-perfect-scrollbar";
import VueApexCharts from "vue3-apexcharts";
import VueTablerIcons from "vue-tabler-icons";
import "vue3-carousel/dist/carousel.css";

import { createI18n } from "vue-i18n";
import messages from "@/utils/messages.ts";
import VueScrollTo from "vue-scrollto";
import VueEasyLightbox from "vue-easy-lightbox";

const i18n = createI18n({
  locale: "ko",
  messages: messages,
  silentTranslationWarn: true,
  silentFallbackWarn: true
});

const app = createApp(App);
app.use(createPinia());
app.use(router);
app.use(PerfectScrollbar);
app.use(VueTablerIcons);
app.use(i18n);
app.use(VueApexCharts as any);
app.use(vuetify).mount("#app");
app.use(VueScrollTo, {
  duration: 1000,
  easing: "ease"
});
app.use(VueEasyLightbox);
